const numberOfDigits = (value) => (Number.isInteger(value) ? 0 : 2);

export default (valueAmount) => (
  new Intl.NumberFormat(
    'en-US',
    {
      minimumFractionDigits: numberOfDigits(valueAmount),
      maximumFractionDigits: 2,
    },
  ).format(valueAmount)
);
